import { Link, useLocation } from 'react-router';
import GridShape from '../../components/common/GridShape';
import PageMeta from '../../components/common/PageMeta';

export default function Unauthorized() {
  const location = useLocation();
  const message =
    location.state?.message ||
    'You do not have permission to access this application, or sign-in failed.';

  return (
    <>
      <PageMeta
        title="Unauthorized | QC Lite"
        description="Access denied or sign-in error."
      />
      <div className="relative z-1 flex min-h-screen flex-col items-center justify-center overflow-hidden p-4 sm:p-6 md:p-8">
        <GridShape />
        <div className="mx-auto w-full max-w-[242px] text-center sm:max-w-[472px]">
          <h1 className="mb-6 font-bold text-gray-800 text-title-md dark:text-white/90 sm:mb-8 xl:text-title-2xl">
            ACCESS DENIED
          </h1>

          <img
            src="/images/error/404.svg"
            alt=""
            className="mx-auto dark:hidden"
          />
          <img
            src="/images/error/404-dark.svg"
            alt=""
            className="mx-auto hidden dark:block"
          />

          <p className="mt-8 mb-2 text-base text-gray-700 dark:text-gray-400 sm:mt-10 sm:text-lg">
            {message}
          </p>
          <p className="mb-6 text-sm text-gray-500 dark:text-gray-500 sm:mb-8 sm:text-base">
            If you need access, contact your administrator or try signing in
            again.
          </p>

          <Link
            to="/signin"
            className="inline-flex w-full items-center justify-center rounded-lg bg-brand-500 px-5 py-3.5 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600 sm:w-auto"
          >
            Back to sign in
          </Link>
        </div>
        <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-center text-sm text-gray-500 dark:text-gray-400 sm:bottom-6">
          &copy; {new Date().getFullYear()} QC Lite
        </p>
      </div>
    </>
  );
}
